$('#rotateStatments').on("click", function(e){
    if($("#rotateStatments").prop('checked')){
        $('.blockStatementSwitch').removeClass('hide');

    } else {
        e.preventDefault();
        Swal.fire({
            title: "Are you sure?",
            text: "Statements will not be rotated",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            confirmButtonClass: "btn btn-success btn-min-width mt-2",
            cancelButtonClass: "btn btn-danger btn-min-width ml-2 mt-2",
        }).then((result) => {
            $('#rotateStatments').prop("checked", !result.value);
            if (result.value === true) {
                $('.blockStatementSwitch').addClass('hide');
            }
        })
    }
});
